import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Button, Row, Col, Form, Input, Switch, Modal } from "antd";
import LogoImage from "../assets/images/my-health-my-way.png";
// import BackgroundImg from "../assets/images/for-login-page-background.png";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import { AuthContext } from "../context/AuthContext";
import Loader from "../components/Loader";
import encryptDecrypt from "../helper/encryptDecrypt";
// const { Title } = Typography;
const { Content } = Layout;

const SignIn = () => {
  const { setIsLoggedIn, setUserProfile } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [resetModal, setResetModal] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [isOtpValid, setIsOtpValid] = useState(false);
  const { request } = useRequest();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const email = Form.useWatch("email", form);
  const password = Form.useWatch("password", form);

  const isFormValid =
    email && password && email.trim() !== "" && password.trim() !== "";
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();
  const onFinish = (values) => {
    onSubmit(values);
  };

  // const handleFormChange = (_, allValues) => {
  //   const { email, password } = allValues;

  //   if (
  //     email &&
  //     password &&
  //     email.trim() !== "" &&
  //     password.trim() !== ""
  //   ) {
  //     setIsFormValid(true);
  //   } else {
  //     setIsFormValid(false);
  //   }
  // };


  const onSubmit = (values) => {
    const { email, password } = values;
    if (!email)
      return ShowToast("Please enter email to sign in", Severty.ERROR);
    const payload = { password };
    setLoading(true);
    payload.email = email;
    request({
      url: "/auth/admin/login",
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data?.status || data.requires_2fa) {
          // setIsLoggedIn(true);
          if (rememberMe) {
            var emailEncrypt = encryptDecrypt.encryptEmail(values.email);
            var passwordEncrypt = encryptDecrypt.encryptPassword(
              values.password
            );
            localStorage.setItem("rememberMe", "true");
            localStorage.setItem("ykmCe2AYEFTHobn", emailEncrypt);
            localStorage.setItem("ouUsippetc8S4Ry", passwordEncrypt);
          } else {
            localStorage.removeItem("ykmCe2AYEFTHobn");
            localStorage.removeItem("ouUsippetc8S4Ry");
          }
          setSelected({ email: data.temp_admin.email });
          setOtpModal(true);
          ShowToast(`${data.message}`, Severty.SUCCESS);
        } else {
          ShowToast(data?.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleForgotPassword = () => {
    setVisible(true);
  };

  const handleResetPassword = (data) => {
    // Send the OTP to the user's email
    let payload = {};
    payload.email = data.email;
    // setSelected(data.email);
    request({
      url: "/auth/forgot-password",
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        ShowToast(data.message, Severty.SUCCESS);
        setVisible(false);
        form1.resetFields();
        // setResetModal(true);
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
      },
    });
  };

  const handleVerifyOTP = (values) => {
    const { code } = values;
    // Verify the OTP entered by the user
    let payload = {};
    payload.email = selected.email;
    payload.code = code;
    request({
      url: "/auth/verify-2fa",
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        localStorage.setItem("token", data.access);
        localStorage.setItem("refreshToken", data.refresh);
        localStorage.setItem("session_id", data.session_id);
        localStorage.setItem("user", JSON.stringify(data.user));
        console.log("data.user:", data.user)
        ShowToast(data.message, Severty.SUCCESS);
        setOtpModal(false);
        setIsOtpValid(false);
        setVisible(false);
        form2.resetFields();
        setIsLoggedIn(true);
        setUserProfile(data.user);
        navigate("/dashboard");
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
      },
    });
  };

  const handleReset = (values) => {
    const { newPassword } = values;
    // Reset the password with the new password entered by the user
    let payload = {};
    payload.email = selected.email;
    payload.password = newPassword;
    request({
      url: "/auth/reset-password",
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        ShowToast(data.message, Severty.SUCCESS);
        setResetModal(false);
        form3.resetFields();
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
      },
    });
  };

  const handleCancelReset = () => {
    setResetModal(false);
    form3.resetFields();
  };

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
  const savedEmail = localStorage.getItem("ykmCe2AYEFTHobn");
  const savedPassword = localStorage.getItem("ouUsippetc8S4Ry");
  const isRememberMe = localStorage.getItem("rememberMe");

  if (isRememberMe === "true" && savedEmail && savedPassword) {
    const originalEmail = encryptDecrypt.decryptEmail(savedEmail);
    const originalPassword = encryptDecrypt.decryptPassword(savedPassword);

    form.setFieldsValue({
      email: originalEmail,
      password: originalPassword,
    });

    setRememberMe(true);
  } else {
    setRememberMe(false);
  }
}, [form]);

  return (
    <>
      {loading && <Loader />}
      <Layout className="layout-default layout-signin-bg"></Layout>
      <Layout className="layout-default layout-signin">
        <Row className="align-items-center layout-signin-rowsss">
          <Col span={24} lg={24} className="">
            <Content className="signin">
              <div className="signin-box">
                <div className="signup-logo">
                  <div className="brand_logo">
                    <img src={LogoImage} alt="Logo" />
                  </div>
                  <h2>Welcome Admin Panel</h2>
                  <h4>Sign in to continue</h4>
                </div>
                <Row justify="space-around">
                  <Col xs={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }}>
                    <div className="signup-form">
                      {/* <Title className="mb-15">Sign In</Title>
                      <Title className="font-regular text-muted" level={5}>
                        Enter your email and password to sign in
                      </Title> */}
                      <Form
                        form={form}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        // onValuesChange={handleFormChange}
                        layout="vertical"
                        className="row-col"
                      >
                        <Form.Item
                          className="username"
                          label="Email"
                          name="email"
                          normalize={(value) => value?.trim()}
                          rules={[
                            {
                              required: true,
                              message: "Please input your email!",
                            },
                            {
                              type: "email",
                              message: "The input is not valid E-mail!",
                            },
                            {
                              max: 100,
                              message: "Email cannot exceed 100 characters",
                            },
                          ]}
                        >
                          <Input placeholder="Email" />
                        </Form.Item>

                        <Form.Item
                          className="username"
                          label="Password"
                          name="password"
                          normalize={(value) => value?.trim()}
                          rules={[
                            {
                              required: true,
                              message: "Please input your password!",
                            },
                            {
                              max: 100,
                              message: "Password cannot exceed 100 characters",
                            },
                          ]}
                        >
                          <Input.Password placeholder="Password" />
                        </Form.Item>
                        <div className="forgot-pass">
                          <Form.Item
                            name="remember"
                            className="aligin-center"
                            valuePropName="checked"
                          >
                            <Switch
                              checked={rememberMe}
                              onChange={(checked) => {
                                setRememberMe(checked);
                                if (!checked) {
                                  // Remove saved credentials when remember me is unchecked
                                  localStorage.removeItem("rememberMe");
                                  localStorage.removeItem("ykmCe2AYEFTHobn");
                                  localStorage.removeItem("ouUsippetc8S4Ry");
                                }
                              }}
                            />
                            Remember me
                          </Form.Item>
                          <Form.Item
                            name="remember"
                            className="aligin-center"
                            valuePropName="checked"
                          >
                            <div
                              className="forgate-btn"
                              onClick={handleForgotPassword}
                            >
                              <a>Forgot Password</a>
                            </div>
                          </Form.Item>
                        </div>

                        <Form.Item>
                          <Button
                            type="primary"
                            htmlType="submit"
                            style={{ width: "100%" }}
                            disabled={!isFormValid}
                          >
                            SIGN IN
                          </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </Col>
                  {/* <Col
                className="sign-img"
                style={{ padding: 12 }}
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                md={{ span: 12 }}
              >
                <img src={signinbg} alt="" />
              </Col> */}
                </Row>
              </div>
            </Content>
          </Col>
          {/* <Col span={24} lg={17} className="signin-bg">
           <img src={BackgroundImg} /> 
            
          </Col> */}
        </Row>

        {/* Forgot Password Modal */}
        <Modal
          open={visible}
          title="Forgot Password"
          okText="Ok"
          onCancel={() => {
            setVisible(false);
            form1.resetFields();
          }}
          okButtonProps={{
            form: "forget-pasword",
            htmlType: "submit",
            loading: loading,
          }}
        >
          <Form
            id="forget-pasword"
            form={form1}
            onFinish={handleResetPassword}
            layout="vertical"
          >
            <Form.Item
              label="Email"
              name="email"
              normalize={(value) => value?.trim()}
              rules={[
                {
                  required: true,
                  message: "Please input your email!",
                },
              ]}
            >
              <Input placeholder="Please Enter Email" />
            </Form.Item>
          </Form>
        </Modal>

        {/* OTP Modal */}
        <Modal
          open={otpModal}
          title="Verify OTP"
          okText="Ok"
          onCancel={() => {
            setOtpModal(false);
            setIsOtpValid(false);
            form2.resetFields();
          }}
          okButtonProps={{
            form: "verify-otp",
            htmlType: "submit",
            loading: loading,
            disabled: !isOtpValid,
          }}
        >
          <Form
            id="verify-otp"
            form={form2}
            onFinish={(e) => handleVerifyOTP(e)}
            layout="vertical"
          >
            <Form.Item
              label="OTP"
              name="code"
              normalize={(value) => value?.trim()}
              rules={[
                {
                  required: true,
                  message: "Please enter the OTP",
                },
                {
                  pattern: /^\d{6}$/,
                  message: "OTP must be 6 digits",
                },
              ]}
            >
              <Input
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={6}
                onKeyDown={(e) => {
                  const allowedKeys = [
                    "Backspace",
                    "Delete",
                    "ArrowLeft",
                    "ArrowRight",
                    "Tab",
                    "Home",
                    "End",
                  ];
                  if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey) {
                    return;
                  }
                  if (!/^\d$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                onPaste={(e) => {
                  const pasted = (
                    e.clipboardData || window.clipboardData
                  ).getData("text");
                  if (!/^\d+$/.test(pasted)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  const digitsOnly = (e.target.value || "")
                    .replace(/\D/g, "")
                    .slice(0, 6);
                  form2.setFieldsValue({ code: digitsOnly });

                  // ✅ enable OK button only when exactly 6 digits
                  setIsOtpValid(digitsOnly.length === 6);
                }}
                placeholder="Enter OTP"
              />
            </Form.Item>
          </Form>
        </Modal>

        {/* Reset Password Modal */}
        <Modal
          open={resetModal}
          title="Reset Password"
          okText="Ok"
          onCancel={handleCancelReset}
          okButtonProps={{
            form: "reset-password",
            htmlType: "submit",
            loading: loading,
          }}
        >
          <Form
            id="reset-password"
            form={form3}
            onFinish={(e) => handleReset(e)}
            layout="vertical"
          >
            <Form.Item
              label="New Password"
              name="newPassword"
              normalize={(value) => value?.trim()}
              rules={[
                { required: true, message: "Please input the new password!" },
                {
                  min: 8,
                  message: "Password must be at least 8 characters long!",
                },
                {
                  pattern:
                    /^(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z0-9!@#$%^&*(),.?":{}|<>]+$/,
                  message: "Must include at least one special character",
                },
                {
                  pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z]).+$/,
                  message:
                    "Password must contain at least one uppercase letter, one number, and one lowercase letter!",
                },
                {
                  max: 100,
                  message: "Password cannot exceed 100 characters",
                },
              ]}
            >
              <Input.Password placeholder="Please Enter Password" />
            </Form.Item>
            <Form.Item
              label="Confirm New Password"
              name="confirm_new_password"
              dependencies={["newPassword"]}
              hasFeedback
              normalize={(value) => value?.trim()}
              rules={[
                {
                  required: true,
                  message: "Please input the confirm password!",
                },
                {
                  pattern:
                    /^(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z0-9!@#$%^&*(),.?":{}|<>]+$/,
                  message: "Must include at least one special character",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("newPassword") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Passwords that you entered do not match!")
                    );
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Please Enter Confirm Password" />
            </Form.Item>
          </Form>
        </Modal>
      </Layout>
    </>
  );
};

export default SignIn;
